query UserProfilesActiveCount(
  $first: Int
  $after: Cursor
  $orderBy: [UserProfilesOrderBy!]
  $filter: UserProfileFilter
) {
  userProfiles(
    first: $first
    after: $after
    orderBy: $orderBy
    filter: $filter
  ) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
    totalCount
    nodes {
      id
      _signinInfo{
        profileIconState
        profileIconType
        isUserAdministrator
        isProjectSupervisor
        isActivateAllowed
        isDeactivateAllowed
      }
      _activeApprovalCount
      __typename
      _urgencyLevel
      _rowTimestamp
      name
      description
      emailAccount
      _isStagedToInvite
      departmentOccupationTemplateId
      _lastUsedDate
     
      userRankTypeId
      userRankType {
        userRank
        id
      }
      secureRowLevelId
      secureRowLevel {
        id
        securityLevel
      }

      departmentOccupationTemplate {
        name
        description
        isTemplateControlled
        
      }
      roleId
      role {
        name
        id
        description
      }
      userOccupationTitleId
      userOccupationTitle {
        userOccupationTitle
        userRankTypeId
      }
      departmentId
      department {
        name
      }
      departmentGroupId
      departmentGroup {
        name
      }
      communicationGroupId
      communicationGroup {
        name
      }
      tagGroupId
      tagGroup {
        name
      }
      dataAccessPolicyId
      dataAccessPolicy {
        name
      }
      accessGroupId
      accessGroup {
        name
        _isStagedApprovalRequest
        _isUpdatable
        _isDeletable
        _isApproved
        _isApprovalRevocable
      }
      userGroupId
      userGroup {
        name
      }
      invited
      _invitationStatusTypeId
      inviteStatusType {
        statusType
      }
      _statusTypeId
      statusType {
        statusType
      }
      _isUpdatable
      _isDeletable
      _isStagedApprovalRequest
      _isStagedToInvite
      _isUserApprovalTreeViewer
      _isAuthenticatedUser
      _isProfileValidated
      userApprovalGrants(
        orderBy: APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC
      ) {
        nodes {
          isApprover
          isRequester
          isAddingNonApproversAllowed
          isApprovalRevokingEnabled
          isApprovalTreeViewerAllowed
          isAutoApproveEnabled
          isEnMasseApprovalsEnabled
          isExtendedApprover
          isLowerTreeLevelBypassEnabled
          isSelfApproveEnabled
        }
      }
      entityDocumentsByEntityId {
        nodes {
          id
          fileReference
          _documentContents
        }
      }
      userProfileHistoriesByEntityId {
        nodes {
          crudOperation
          pointInTimeDate
          tenantUserName
        }
      }
      notesByEntityId {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
